import React from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as LogoIcon } from '../../assets/icons/onlyplay_logo_birthday.svg';

export default function Logo() {
  return (
    <NavLink to={'/'}>
      <LogoIcon />
    </NavLink>
  );
}
